import { Badge, Breadcrumb, Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';

// images
import img1 from 'assets/images/avatars/img-4.jpg';
import { Post2 } from 'components/blog';
type HeroProps = {
    post: Post2 | null;
};
const Hero = ({ post }: HeroProps) => {
    console.log('POst Hero', post);

    return (
        <>

            {/* <section
                style={{
                    background: "linear-gradient(135deg, #e3f2fd 0%, #e8f0ff 100%)",
                    padding: "80px 0",
                    textAlign: "center",
                    borderBottomLeftRadius: "30px",
                    borderBottomRightRadius: "30px",
                    marginLeft: 25,
                    marginRight: 25
                }}     >
                <h1 style={{ fontSize: "48px", fontWeight: "700", color: "#1b1f29", }}  >
                    About Us
                </h1>
                <p style={{ marginTop: "10px", fontSize: "18px", color: "#6c757d", }}   >
                    SalesTrackify is a smart, scalable CRM platform built by
                    <strong> CoreScripts Technologies Ltd</strong>, a UK-based IT company.
                </p>
            </section> */}
            <section>

                <section className="hero-4 pb-5 pt-8 pt-lg-6 pb-sm-4 " style={{
                    background: "linear-gradient(135deg, #d7e9ff 0%, #ffffff 20%, #e3ebff 100%)",
                    padding: "80px 0",
                    textAlign: "center",
                    borderBottomLeftRadius: "30px",
                    borderBottomRightRadius: "30px",
                    marginLeft: 25,
                    marginRight: 25
                }}  >

                    <Container>
                        <Row className="justify-content-center">
                            <Col lg={12}>
                                <div className="mt-4">
                                    <Link to="#">
                                        <Badge bg="" className="badge-soft-orange mb-1 px-5 py-3">
                                            {post?.blogTags}
                                        </Badge>
                                    </Link>
                                </div>
                                <h1 className="hero-title mt-0">{post?.blogTitle}</h1>
                            </Col>
                        </Row>
                    </Container>
                </section>

                <Container>

                    <Row className="mt-7 align-items-center">
                        <Col xs="auto">
                            <div className="d-flex align-items-center">
                                <div>
                                    <p className="font-weight-bold mb-0 fs-18">
                                        {post?.createdOn
                                            ? new Intl.DateTimeFormat("en-US", {
                                                day: "numeric",
                                                month: "long",
                                                year: "numeric"
                                            }).format(new Date(post.createdOn))
                                            : null}
                                    </p>
                                </div>
                            </div>
                        </Col>
                        <Col>
                        </Col>
                    </Row>
                </Container>
            </section>

        </>
    );
};

export default Hero;
